import { toast } from 'sonner';

export interface ToastProps {
  title: string;
  message?: string;
}

export const useHandleSuccess = (props: ToastProps) => {
  const { title, message } = props;

  return () => {
    toast(title, {
      classNames: {
        toast: 'bg-green-600 text-white border-0',
      },
      description: message ? message : 'Operation has been completed successfully.',
      duration: 1000,
    });
  };
};
